import { RefreshButton } from "@/components/common/RefreshButton";
import { DeleteOutlined, DownOutlined, EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { RESOURCE_TYPE_USERS } from "./users";
import { useTranslation } from "react-i18next";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceInvalidate } from "@/hooks";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceDelete } from "@/hooks/useResourceDelete";

const RESOURCE = RESOURCE_TYPE_USERS;

export const UsersActions = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const invalidate = useResourceInvalidate();
  const { mutateAsync: deleteMutateAsync } = useResourceDelete();

  const navigateToCreation = () => {
    navigate({ resource: RESOURCE, action: 'create' });
  };

  const { state } = useResourceContext();
  const [selectedUser] = state.selectedResources;

  const actionsMenu = [
    {
      key: "edit",
      label: t("actions.edit", "Edit"),
      icon: <EditOutlined />,
    },
    {
      key: "delete",
      label: t("actions.delete", "Delete"),
      icon: <DeleteOutlined />,
    },
  ];

  const onClickAction = async (action) => {
    console.log("Action clicked", action);
    switch (action.key) {
      case "edit":
        navigate({ resource: RESOURCE, action: 'edit', key: selectedUser.name });
        break;
      case "delete":
        await deleteMutateAsync({ resource: RESOURCE, id: selectedUser.name });
        break;
      default:
        console.log("Unknown action", action);
    }
  };

  return [
    <Dropdown
      key="actions"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("instances.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Button key='launch' icon={<PlusCircleOutlined />} onClick={navigateToCreation}>{t('users.menu.create')}</Button>,
    <RefreshButton key='refresh' onClick={() => {
      invalidate({
        resource: RESOURCE,
        invalidates: ["list"],
      });
    }} />,
  ];
};